<!-- Footer -->
<ng-template #pageFooter>
  @if ( !isEmbed ) {
  <footer class="always-flex">
    @if (!appConfig?.production) {
    <button #versionTrigger="matMenuTrigger" mat-button color="primary"
      [matMenuTriggerFor]="versionMenu">{{appConfig?.description ?? 'Version'}}
      {{appConfig?.serviceVersion}}</button>
    <mat-menu #versionMenu='matMenu'>
      @if ( !!appConfig ) {
      <button #serviceTrigger="matMenuTrigger" mat-menu-item [matMenuTriggerFor]="serviceMenu">Mutara</button>
      }
    </mat-menu>
    <mat-menu #serviceMenu='matMenu'>
      @if (!!appConfig) {
      <div mat-menu-item>
        {{appConfig?.serviceDescription}}</div>
      <div mat-menu-item>Version {{appConfig?.serviceVersion}} [{{appConfig?.database}}]</div>
      <div mat-menu-item>Deployed: {{getDeployTime()}}</div>
      <div mat-menu-item>Started: {{appConfig?.serviceStarted?.toString()}}</div>
      @for( integrated of appConfig?.integrations; track integrated.description) {
      <div mat-menu-item>{{integrated.description}}</div>
      }
      <button mat-menu-item type="button" (click)="toggleEditor()">Editor</button>
      <button mat-menu-item type='button' (click)="dumpForm()">Dump Form Data</button>
      <button mat-menu-item type='button' [disabled]='!isLoggedIn' (click)="fakeSubmit()">Fake Submission</button>
      }
    </mat-menu>
    }
    @if (appConfig?.production ) {
    <button mat-button color="primary" #empty>{{appConfig?.description}}</button>
    }
    @if ( !!message ) {
    <mat-icon aria-label='Message of the Day' color='primary' matTooltip='Message of the Day'
      (click)="showMOTD()">message</mat-icon>
    }

    <mutara-message-bar role="status" [message]="appConfig?.notes"></mutara-message-bar>
    <a mat-flat-button color="primary" [href]="appConfig?.help?.link ?? ''" target="_blank" rel="noopener"
      aria-labelledby="helptext">{{appConfig?.help?.title}}
      <mat-icon>{{appConfig?.help?.icon ?? 'help'}}</mat-icon>
      <mat-icon>open_in_new</mat-icon></a>
    <span id="helptext" hidden>{{appConfig?.help?.title}}, opens in a new window</span>
  </footer>
  }
</ng-template>


<!-- Toolbar -->
@if ( !isEmbed ) {
<mat-toolbar [class]="{'toolbar': true, 'flair' : appConfig?.flair}" role="banner" #toolbar
  aria-label="application tools">
  <mat-toolbar-row [class]="['toolbar-row','mainbar']">
    <a href="#content" (click)="skipToMainContentClick($event)" class="skip-link" target="_self">Skip to main
      content</a>
    <img class='logo' id='homeimage' alt="{{appConfig?.info?.institution ?? 'University'}} Logo" [src]="homeImage" />
    @if ( appConfig?.flair ) {
    <img id='flairimage' aria-hidden="true" [src]="flairImage" />
    }
    <span class='main-title'>
      @if ( !isVertical ) {
      <span
        [ngStyle]="{'font-family': [(appConfig?.title?.font ?? ''),'Arial', 'Helvetica'].join(','), 'font-size': (appConfig?.title?.size ?? '1em')}">
        {{appConfig?.title?.label}} {{appConfig?.production ? '' : ` (${appConfig?.database})`}}
      </span>
      }
    </span>

    <button mat-flat-button (click)="instructions.toggle()" aria-label="Instructions" matTooltip="Instructions"
      color="primary">
      @if( !isVertical ) {
      <mat-label>Instructions</mat-label>
      }
      <mat-icon>info</mat-icon>
    </button>

    <button #navTrigger="matMenuTrigger" mat-flat-button color="primary" (click)="login($event)"
      matTooltip="{{ (loginData?.username ?? '' ) != '' ? 'Logged in as ' + loginData?.username : 'Sign In'}}"
      [matMenuTriggerFor]="appMenu" aria-labelledby="accountSettingsMenu">
      @if ( !isVertical ) {
      <mat-label>{{ ((loginData?.username ?? '') == '' ) ? "Sign In" : loginData.username }}</mat-label>
      }
      <mat-icon>{{appConfig?.userIcon ?? 'account_circle'}}</mat-icon>
    </button>

    <span hidden id="accountSettingsMenu">
      {{ (loginData?.username ?? '' ) != '' ? 'Logged in as ' + loginData?.username + ', account settings menu' : 'Sign In'}}
    </span>

    <mat-menu #appMenu="matMenu" [title]="loginData.username ?? ''">
      @if ((loginData?.username ?? '') != '' ) {
      <mat-menu-item class="mutara-lr-pad">
        <p class="mutara-lr-pad">Logged In: {{today | date:'yyyy-MM-dd hh:mm'}}</p>
      </mat-menu-item>
      <mat-menu-item class="mutara-lr-pad">
        <p class="mutara-lr-pad">{{loginData.username}}</p>
      </mat-menu-item>
      @if ((layouts?.length ?? 0) > 1 && !isVertical) {
      <mat-divider></mat-divider>
      @for( layout of layouts; track layout.label) {
      <button mat-menu-item (click)='switchLayout(layout)'>
        <mat-icon>{{layout.icon ?? 'apps'}}</mat-icon><span>{{layout.label}}</span>
      </button>
      }
      }

      <mat-divider></mat-divider>
      <button mat-menu-item (click)='instructions.toggle()'>
        <mat-icon>info</mat-icon><span id='txthelp'>Help</span>
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)='logoutUser()'>
        <mat-icon>logout</mat-icon><span>Logout</span>
      </button>
      }
    </mat-menu>
  </mat-toolbar-row>
</mat-toolbar>
}

@if (!!showProgress) {
<mutara-progress-indicator progressType='bar' class='progressbar'></mutara-progress-indicator>
}
<!-- On mobile, this container needs to be reset so the footer gets out of the way -->
<mat-sidenav-container cdkDropListGroup
  [class]="{'embedded': !!isEmbed, 'progressbar-visible': !!showProgress, 'sidenav-container': true}">
  <!-- Vertical navigation -->
  <mat-sidenav #sidenav mode="side" class="sidenav">
    <mutara-navigation></mutara-navigation>
  </mat-sidenav>

  <!-- Instuction panel -->
  <mat-sidenav #instructions mode="side" position="end" class="sidenav">
    <mat-card-actions class='no-padding flex-full' align='end'>
      <button align='end' mat-icon-button (click)='instructions.toggle()' aria-label="Close instructions"
        matTooltip="Close instructions">
        <mat-icon color="primary">close</mat-icon>
      </button>
    </mat-card-actions>
    <mutara-instructions></mutara-instructions>
  </mat-sidenav>

  <!-- Main page outlet -->
  <mat-sidenav-content class="sidenav-content">
    <a id="content" tabindex="-1"></a>
    <router-outlet cdkDropListGroup></router-outlet>
    @if( isVertical ) {
    <ng-template [ngTemplateOutlet]="pageFooter"></ng-template>
    }
  </mat-sidenav-content>
</mat-sidenav-container>
@if( !isVertical ) {
<ng-template [ngTemplateOutlet]="pageFooter"></ng-template>
}